import React, { useState } from "react";
import { Routes, Route, useNavigate } from "react-router-dom";
import GrowthQuizContainer from "./GrowthQuizContainer";
import GrowthResults from "./GrowthResults";
import UserInfoForm, { UserInfo } from "../../components/UserInfoForm";
import { GrowthScores } from "./questions";
import { webhookService } from "../../shared/webhookService";

export interface GrowthResult {
  questionId: number;
  question: string;
  answer: string;
  scores: GrowthScores;
}

const GrowthQuiz: React.FC = () => {
  const [results, setResults] = useState<GrowthResult[]>([]);
  const [showQuiz, setShowQuiz] = useState(false);
  const [userInfo, setUserInfo] = useState<UserInfo | null>(null);
  const navigate = useNavigate();

  const handleUserInfoSubmit = (userData: UserInfo) => {
    setUserInfo(userData);
    setShowQuiz(true);
  };

  const handleQuizComplete = async (quizResults: GrowthResult[]) => {
    setResults(quizResults);

    // Prepare webhook data
    const webhookData = {
      quizName: "Growth Quiz",
      userInfo: userInfo || {},
      responses: quizResults.map((result, index) => ({
        questionNumber: index + 1,
        question: result.question,
        answer: result.answer,
      })),
      timestamp: new Date().toISOString(),
    };

    // Send to webhook (with automatic retry on failure)
    await webhookService.submitQuizData(webhookData);

    navigate("results", { replace: true });
  };

  const handleRestart = () => {
    setResults([]);
    setShowQuiz(false);
    setUserInfo(null);
    navigate(".", { replace: true });
  };

  return (
    <div>
      <Routes>
        <Route
          path="/"
          element={
            showQuiz ? (
              <GrowthQuizContainer onQuizComplete={handleQuizComplete} />
            ) : (
              <UserInfoForm
                onSubmit={handleUserInfoSubmit}
                subtitle="Find Your Re-Invention Focus"
              />
            )
          }
        />
        <Route
          path="results"
          element={
            <GrowthResults results={results} onRestart={handleRestart} />
          }
        />
      </Routes>
    </div>
  );
};

export default GrowthQuiz;
